import { getPluginType } from '@udecode/plate-core';
import {
  ELEMENT_LI,
  ELEMENT_LIC,
  ELEMENT_OL,
  ELEMENT_UL,
} from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

export const getUnorderedListType = (editor: DreamEditor) => getPluginType(editor, ELEMENT_UL);

export const getOrderedListType = (editor: DreamEditor) => getPluginType(editor, ELEMENT_OL);

export const getListTypes = (editor: DreamEditor) => [
  getOrderedListType(editor),
  getUnorderedListType(editor),
];

export const getListItemType = (editor: DreamEditor) => getPluginType(editor, ELEMENT_LI);

export const getListItemContentType = (editor: DreamEditor) => getPluginType(editor, ELEMENT_LIC);
